<template>
    <div>

      <div class="mt-3 text-center">

          <!-- hide options for agent page! -->

      <b-button v-if="filter.minPrice && filter.maxPrice && (filter.minPrice > filter.maxPrice)" class="mr-2 mb-2" variant="danger">Minimum price is bigger than maximum price</b-button>
      <div v-else-if="agent_id==0">

      <b-button class="mr-2 mb-2" v-if="filter.property_type" variant="success">
        {{filter.property_type.name}}s
        <span @click="clearFilter('property_type')" class="badge badge-danger ml-2">X</span></b-button>

      <b-button class="mr-2 mb-2" v-if="filter.province" variant="success">
        {{filter.province.name}}
        <span @click="clearFilter('province')" class="badge badge-danger ml-2">X</span></b-button>

      <b-button class="mr-2 mb-2" v-if="filter.city" variant="success">
        {{filter.city.name}}
        <span @click="clearFilter('city')" class="badge badge-danger ml-2">X</span></b-button>

      <b-button class="mr-2 mb-2" v-if="filter.suburb" variant="success">
        {{filter.suburb.name}}
        <span @click="clearFilter('suburb')" class="badge badge-danger ml-2">X</span></b-button>

      <b-button class="mr-2 mb-2" v-if="filter.bedrooms" variant="success">
        Bedrooms <b-badge variant="light">{{filter.bedrooms}}</b-badge>
        <span @click="clearFilter('bedrooms')" class="badge badge-danger ml-2">X</span></b-button>

      <b-button class="mr-2 mb-2" v-if="filter.bathrooms" variant="success">Bathrooms
        <b-badge variant="light">{{filter.bathrooms}}</b-badge>
        <span @click="clearFilter('bathrooms')" class="badge badge-danger ml-2">X</span></b-button>

      <b-button class="mr-2 mb-2" v-if="filter.minPrice" variant="success">Minimum
        <b-badge variant="light">R {{formatCurrency(filter.minPrice)}}</b-badge>
        <span @click="clearFilter('minPrice')" class="badge badge-danger ml-2">X</span></b-button>

      <b-button class="mr-2 mb-2" v-if="filter.maxPrice" variant="success">Maximum
        <b-badge variant="light">R {{formatCurrency(filter.maxPrice)}}</b-badge>
        <span @click="clearFilter('maxPrice')" class="badge badge-danger ml-2">X</span></b-button>

      <b-button class="mb-2" v-if="filter.sortBy" variant="success">Sort
        <b-badge variant="light">{{filter.sortBy.name}}</b-badge>
        <span @click="clearFilter('sortBy')" class="badge badge-danger ml-2">X</span></b-button>

      </div>
      </div>

<div v-if="agent_id == 0">
      <h4 v-if="filter.property_name" class="mt-2 mb-0 text-center"><b>{{filter.property_name}}s for {{category}}</b> <span class="counter badge badge-pill badge-dark">{{properties.length}}</span></h4>
      <h4 v-else class="mt-2 mb-0 text-center"><b>Properties for {{category}}</b> <span class="counter badge badge-pill badge-dark">{{formatCurrency(total)}}</span></h4>
</div>

  <div class="row">
  <div class="col-md-12">

            <div v-if="loading" class="text-center col py-3 mt-2"><i class="fas fa-spinner fa-spin fa-3x"></i></div>
            <div v-else-if="properties.length == 0" class="text-center col py-3 mt-2">

              <div><i class="fas fa-times-circle fa-3x"></i></div>
              <div class="mt-2">No properties found</div>
              </div>
            <div v-else class="row pt-3">
              <div v-for="(property, index) in properties" :key="index.id" class="col-md-3 p-0 px-md-2 mb-3 d-flex align-items-stretch">
                <div class="card shadow property w-100">
                  <div class="card-body">
                    <a :href="'/view/'+property.id" class="choice">
                    <div>

                      <img v-if="property.images[0]" class="property-thumbnail" :src="property.images[0].url">
                      <img v-else class="property-thumbnail" :src="default_image">

                      </div>
                    <h4 class="title text-center mt-2">{{ property.bedrooms }} bedroom {{ property.property_type.name }} for {{ property.category }} in {{ property.suburb.name }}</h4>
                    <h4 class="price text-center">R {{ formatCurrency(property.price) }} <span class="per-month" v-if="property.price_per && property.category=='rent'">p/{{property.price_per.toLowerCase()}}</span></h4>
                    </a>
                    <table width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tr>
                    <td class="text-center"><span class="mr-3" title="Bedrooms"><i class="fas fa-bed"></i> {{property.bedrooms}}</span> <span title="Bathrooms"><i class="fas fa-bath"></i> {{property.bathrooms}}</span></td>
                  </tr>
                  <tr>
                    <td class="text-center"><small><timeago
                  :datetime="property.created_at"
                  :auto-update="60" :title="formatDateMoment(property.created_at)"></timeago></small></td>
                  </tr>
                </table>

                  </div>
                </div>
              </div>

              </div>
</div>
</div>

    </div>
</template>

<script>
export default {
props: ['category','filter','agent_id'],


  data() {
    return {
      properties: [],
      total: 0,
      // filterInfo: {},
      loading: false,
      default_image: 'https://property64.s3.af-south-1.amazonaws.com/images/image-not-found-1280x820.png',
    };
  },

  mounted() {

    // this.filterInfo = this.filter;

    if(localStorage.getItem('propper_filter')) {

      // this.filterInfo = JSON.parse(localStorage.getItem('propper_filter'));

    } else {
      this.getProperties();
    }

  },

  created() {

    //

  },

  watch: {
  filter() {
    this.getProperties();
  }
  },

  methods: {

    clearFilter(type) {

      switch(type) {
        case 'minPrice': this.minPrice = ''; this.filter.minPrice = ''; break;
        case 'maxPrice': this.maxPrice = ''; this.filter.maxPrice = ''; break;
        case 'sortBy': this.sortBy = ''; this.filter.sortBy = ''; break;
        case 'suburb': this.suburb = ''; this.filter.suburb = ''; break;
        case 'bedrooms': this.bedrooms = ''; this.filter.bedrooms = ''; break;
        case 'bathrooms': this.bathrooms = ''; this.filter.bathrooms = ''; break;
        case 'property_type': this.property_type = ''; this.filter.property_type = ''; break;
        case 'province': this.province = ''; this.filter.province = ''; break;
        case 'city': this.city = ''; this.filter.city = ''; break;
      }

      this.getProperties();
      this.$emit('myClearFilter', type);

    },

    childMethod() {
      this.getProperties();
    },

    getProperties() {

      this.loading = true;

      this.filter.agent_id = this.agent_id;

      axios.post("/products/list", {filter: this.filter}).
      then((response) => {
        console.log(response.data);
        this.properties = response.data.properties;
        this.total = response.data.properties.length;
        this.loading = false;

        localStorage.setItem('propper_filter', JSON.stringify(this.filter));

      });
    },

  }

}

</script>

<style scoped>

/* Small Devices, Tablets */
@media only screen and (min-width : 768px) {

}

/* Medium Devices, Desktops */
@media only screen and (min-width : 992px) {

  img.property-thumbnail {
    height: 8em;
  }

}

/* Large Devices, Wide Screens */
@media only screen and (min-width : 1200px) {

  img.property-thumbnail {
    height: 8em;
  }

}

span.counter.badge {
font-weight: normal;
font-size: 1rem;
position: relative;
top: -0.15rem; }

img.property-thumbnail {
  width: 100%;
  border-radius: 0.25rem;
  object-fit: cover;
}

h4.title {
  font-size: 1rem;
  margin-bottom: 0;
  font-weight: bold;
}

h5 {
  font-size: 1rem;
  margin-bottom: 0;
  font-weight: bold;
}
h4.price{color: #09b3e7; font-weight: bold; margin-bottom: 0; font-size: 1rem;}
span.per-month{font-size: 1.1rem; color: black; font-weight: normal;}

  a.choice:link, a.choice:visited {
    color: rgb(37, 37, 37);
    text-decoration: none;
    background-color: transparent;
}
a.choice:hover {
    color: #2f4c66;
    text-decoration: none;
    background-color: transparent;
}
a.choice:active {
    color: rgb(37, 37, 37);
    text-decoration: none;
    background-color: transparent;
}
 div.card.shadow.property:hover {
   border: 1px solid rgba(0, 0, 0, 0.2);
 }
 .badge {
  font-size: 80%;
  border-radius: 0.25rem;
  font-weight: normal;
  text-transform: uppercase;
  padding: 0.2rem 0.4rem;
  font-weight:bold;
  margin-left: 0.2rem;
}
.badge-danger {
  color: #fff;
  background-color: #1b2935;
}
</style>
